export class StringUtils {
  static uncapitalize(string: string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
  }

  static formatForHtml(text: string) {
    if (text.includes('</')) {
      return text;
    }

    return text.replaceAll('\n', '<br>');
  }

  static isHtml(text: string) {
    return text.includes('</') || text.includes('<br>'); // This may need expanding, some prompts have little evidence they are HTML
  }

  static deserialize(data: object | JSON): string {
    return JSON.stringify(data);
  }

  static serialize(data: object | string): JSON {
    return JSON.parse(JSON.stringify(data));
  }

  static pluraliseEntity(entityLabel: string) {
    type EntityMap = {
      [key: string]: string;
    };
    const entityPluralMap: EntityMap = {
      candidate: 'Candidates',
      professional: 'Professionals',
      contractor: 'Contractors',
      provider: 'Providers',
      applicant: 'Applicants',
      'job-seeker': 'Job-seekers'
    };
    const pluralLabel = entityPluralMap[entityLabel.toLowerCase()];
    if (pluralLabel) {
      return pluralLabel;
    } else {
      return entityLabel + '(s)';
    }
  }
}
